<main role="main" class="container">
  <div id="step1">
    <div class="sp-create-project-selection">

      <!-- Facebook & Instagram Audiences Card -->
      <app-sp-card-selector
        title="Facebook & Instagram audiences"
        description="Create an audience based on socio-demographic, behavioral and interest criteria."
        iconVariant="Multisex"
        buttonVariant="secondary"
        (cardClick)="selectTypeOfProject('facebook-interest')">
      </app-sp-card-selector>

      <!-- First Party Data Audiences Card -->
      <app-sp-card-selector
        title="First party data audiences"
        description="Import (lookalike) custom audiences from your Facebook ads manager."
        iconVariant="DatabaseLightning"
        buttonVariant="secondary"
        [disabled]="freemium"
        [showButton]="!freemium"
        (cardClick)="selectTypeOfProject('facebook-import')">
      </app-sp-card-selector>

      <!-- Facebook Fan Page Card -->
      <app-sp-card-selector
        title="Facebook fan page"
        description="Select the fanpage for whom you have the « advertiser » or « admin role »."
        iconVariant="Nationality"
        buttonVariant="secondary"
        [disabled]="freemium"
        [showButton]="!freemium"
        (cardClick)="selectTypeOfProject('facebook-page')">
      </app-sp-card-selector>

      <!-- AI-Powered Audience Builder Card -->
      <app-sp-card-selector
        title="AI-Powered audience builder"
        description="Let AI help you define your target audience through a conversational interface."
        iconVariant="Sparks"
        iconClass="color-orange-500"
        buttonVariant="primary"
        buttonText="Build with AI"
        badge="Beta"
        (cardClick)="openAiBuilder()">
      </app-sp-card-selector>
    </div>

    <!-- AI Audience Builder Inline -->
    <div *ngIf="showAiBuilder" #aiBuilderContainer>
      <app-ai-audience-definition
        [onApplyAudience]="onAiAudienceConfirmed.bind(this)">
      </app-ai-audience-definition>
    </div>
  </div>
</main>
